import { useState } from 'react'
import { agencies } from '@/content/missions'
import { usePrefs } from './prefs'

/** Applies a random agency other than the current one, with a message to announce. */
export function useSurprise() {
  const { prefs, set } = usePrefs()
  const [announcement, setAnnouncement] = useState('')
  const surprise = () => {
    const others = agencies.filter((agency) => agency.id !== prefs.mission)
    const pick = others[Math.floor(Math.random() * others.length)]
    if (!pick) return
    set('mission', pick.id)
    setAnnouncement(`Applied the ${pick.name} theme`)
  }
  return { surprise, announcement }
}
